import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const UtensilBowl = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG height={24} width={24} viewBox='0 0 24 24' {...props}>
    <mask id='path-1-inside-1_4580_27766'>
      <Path d='M2 9.25C2 9.11193 2.11193 9 2.25 9H21.75C21.8881 9 22 9.11193 22 9.25V12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12V9.25Z' />
    </mask>
    <Path
      d='M2 9.25C2 9.11193 2.11193 9 2.25 9H21.75C21.8881 9 22 9.11193 22 9.25V12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12V9.25Z'
      fill='currentColor'
    />
    <Path
      d='M2.25 11H21.75V7H2.25V11ZM20 9.25V12H24V9.25H20ZM4 12V9.25H0V12H4ZM12 20C7.58172 20 4 16.4183 4 12H0C0 18.6274 5.37258 24 12 24V20ZM20 12C20 16.4183 16.4183 20 12 20V24C18.6274 24 24 18.6274 24 12H20ZM21.75 11C20.7835 11 20 10.2165 20 9.25H24C24 8.00736 22.9926 7 21.75 7V11ZM2.25 7C1.00736 7 0 8.00736 0 9.25H4C4 10.2165 3.2165 11 2.25 11V7Z'
      fill='currentColor'
      mask='url(#path-1-inside-1_4580_27766)'
    />
    <Path d='M11 9L9.25 4M4 4L7.5 9' stroke='currentColor' strokeWidth={2} strokeLinecap='square' />
  </SVG>
);
